import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-forbidden",
  "use": "icon-forbidden-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 22\" id=\"icon-forbidden\">\n    <path d=\"M4.645 18.093A9.465 9.465 0 0 0 11 20.53a9.5 9.5 0 0 0 9.5-9.5 9.465 9.465 0 0 0-2.438-6.355L4.645 18.093zm-.707-.707L17.355 3.969A9.465 9.465 0 0 0 11 1.531a9.5 9.5 0 0 0-9.5 9.5c0 2.443.922 4.671 2.438 6.355zM11 21.53C5.201 21.53.5 16.83.5 11.03.5 5.23 5.201.53 11 .53s10.5 4.7 10.5 10.5c0 5.799-4.701 10.5-10.5 10.5z\" fill=\"currentColor\" fill-rule=\"nonzero\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol